module.exports = __webpack_public_path__ + "files/8989e7904518ebb1f8ac1f7a4842610b.png";